import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { bool, array, func } from 'prop-types';
import reorderTabs from '../libs/reorderTabs';
import MenuHeaderInput from './MenuHeaderInput';
import SubTab from './SubTab';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import DragIcon from '@mui/icons-material/DragHandle';
import sty from '../styles/SubTabs.module.css';

/**
 * @component SubTabList
 * @param { Object } props
 * @param { boolean } props.isCheckAll
 * @param { array } props.groupSubtabs
 * @param { boolean } props.isLoading
 * @param { function } props.onCheck
 * @param { function } props.onCheckAll
 * @param { function } props.onHandle
 * @param { function } props.onSetSubtabs
 * @returns { JSX.Element }
 */
function SubTabList(props) {
	const onDragEnd = (result) => {
		if (!result.destination) return;
		const results = reorderTabs(props.groupSubtabs, result);
		props.onSetSubtabs(results);
	};

	return (
		<section className={sty.subtab_list_section}>
			<section className={sty.subtab_list_header}>
				<IconButton className={sty.hidden_icon}>
					<DragIcon />
				</IconButton>
				<Checkbox
					className={sty.header_checkbox}
					sx={{ '&.Mui-checked': { color: 'var(--cl-common-white)' } }}
					checked={props.isCheckAll}
					onClick={(e) => props.onCheckAll(e.target.checked)}
				/>
				<MenuHeaderInput value="Name" />
				<MenuHeaderInput value="URL" />
				<MenuHeaderInput value="Description" />
			</section>
			<DragDropContext onDragEnd={onDragEnd}>
				<Droppable droppableId="subtabs" direction="vertical">
					{(provided) => (
						<>
							<section
								className={sty.subtab_list_list}
								ref={provided.innerRef}
								{...provided.droppableProps}
							>
								{props.groupSubtabs.map((tab, index) => (
									<SubTab
										key={index}
										index={index}
										tab={tab}
										onCheck={props.onCheck}
										onHandle={props.onHandle}
									/>
								))}
							</section>
							{provided.placeholder}
							{props.groupSubtabs.length === 0 && (
								<div className={sty.empty}>-- No subtab have been selected yet. --</div>
							)}
						</>
					)}
				</Droppable>
			</DragDropContext>
		</section>
	);
}

SubTabList.propTypes = {
	isCheckAll: bool,
	groupSubtabs: array,
	isLoading: bool,
	onCheck: func,
	onCheckAll: func,
	onHandle: func,
	onSetSubtabs: func,
};

export default SubTabList;
